import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { customerTenant } from '@env/environment';

@Component({
    selector: 'app-card-template',
    standalone: true,
    templateUrl: './card-template.component.html',
    styleUrls: ['./card-template.component.scss'],
    imports: [CommonModule, SpinnerComponent],
})
export class CardTemplateComponent {
    @Input() card: any | undefined;
    // @Input() isLoading:any;
    @Input() size = 'LG';
    @Input() isCardProduct = false;
    @Input() skinImg = '../../../../assets/visa-debit.svg';
    freezeImg = '../../../../assets/freeze.svg';
    tenantKey = localStorage.getItem('tenantKey');
    isNassPay = false;
    customerTenant = customerTenant;
    currentTenant = localStorage.getItem('tenantKey')!;

    constructor() {
        const tenantKey = localStorage.getItem('tenantKey') || '';
        if (tenantKey.startsWith('tenant37') || tenantKey.startsWith('tenant01')) {
            this.isNassPay = true;
        }
    }

    getCardNumber(bin: string, last4: string): string {
        if (bin.length < 4 || last4.length !== 4) {
            return 'Invalid input';
        }

        const isNeoTenant = this.currentTenant.split('_')[0] === customerTenant.INC;

        const maskedBin = '*'.repeat(bin.length);
        const formattedCardNumber = isNeoTenant ? `${maskedBin} **** **** ${last4}` : bin.substring(0, bin.length - 2) + ' **** **** ' + last4;

        return formattedCardNumber;
    }

    getCardBin(bin: string, last4: string): string {
        const last4Formatter = last4 || '****';
        const isNeoTenant = this.currentTenant.split('_')[0] === customerTenant.INC;

        const maskedBin = '*'.repeat(bin.length);
        const spacedBin = maskedBin.replace(/(.{4})/g, '$1 ').trim();

        const formattedCardNumber = isNeoTenant ? `${spacedBin} **** ${last4Formatter}` : bin?.replace(/(.{4})/, '$1 ') + '** ****' + last4Formatter;

        return formattedCardNumber;
    }
}
